import { setupResourceStore } from '@/utils'
import User from '@/resources/User';

const resource = setupResourceStore(User)


const state = {
  ...resource.state
};

const getters = {
  ...resource.getters
};

const actions = {
  ...resource.actions
};

const mutations = {
  ...resource.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};